<template>
    <div class="MAM_queryList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="queryForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="queryForm.merchant_number" placeholder="请输入商户编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.merchant_name" placeholder="请输入商户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.agent_no" placeholder="请输入直属代理商编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.p1_agent_no" placeholder="请输入所属代理编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.transaction_number" placeholder="请输入交易流水号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.terminal_type" clearable placeholder="请选择终端类型">
                        <el-option label="银盛" :value="1"></el-option>
                        <el-option label="杉德" :value="3"></el-option>
                        <el-option label="联动" :value="4"></el-option>
                        <el-option label="海科" :value="5"></el-option>
                        <el-option label="银盛尊享" :value="6"></el-option>
                        
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.card_type" clearable placeholder="请选择卡类型">
                        <el-option label="借记卡" :value="1"></el-option>
                        <el-option label="贷记卡" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.gray_plan_type" clearable placeholder="请选择逻辑类型">
                        <el-option label="旧逻辑" :value="1"></el-option>
                        <el-option label="新逻辑" :value="2"></el-option>
                    </el-select>
                </el-form-item>
               <el-form-item>
               	<el-date-picker
               	    v-model="rangeDate"
               	    type="daterange"
               	    range-separator="至"
               	    start-placeholder="交易开始日期"
               	    end-placeholder="交易结束日期"
               	    value-format="yyyy-MM-dd"
               	    @change="pickerChange"
               	></el-date-picker>
               </el-form-item>
               <el-form-item>
               	<el-date-picker
               	    v-model="rangeDate2"
               	    type="daterange"
               	    range-separator="至"
               	    start-placeholder="恢复开始日期"
               	    end-placeholder="恢复结束日期"
               	    value-format="yyyy-MM-dd"
               	    @change="pickerChange2"
               	></el-date-picker>
               </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"  @click="onSearch(queryForm)">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-download"
                      :loading="downLoading"
                      @click="handleDownLoad(queryForm)"
                  >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">

            <el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="brand_name" label="政策名称"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="transaction_number" label="交易流水号"></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="terminal_type_text" label="终端类型"></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="merchant_number" label="商户编号"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="merchant_name" label="商户名称"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="terminal_sn" label="终端SN"></el-table-column>
                 <el-table-column width="150px" header-align="center" align="center" prop="nickname" label="直属代理商昵称"></el-table-column>
                 <el-table-column width="150px" header-align="center" align="center" prop="agent_no" label="直属代理商编号"></el-table-column> 
                  <el-table-column  width="150px" header-align="center" align="center" prop="p1_nickname" label="所属机构昵称"></el-table-column>
                  <el-table-column  width="150px" header-align="center" align="center" prop="p1_agent_no" label="所属机构编号"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="card_type_text" label="交易卡类型"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="transaction_money" label="交易金额(元)"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="gray_plan_type_text" label="逻辑类型"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="create_time" label="优化时间"></el-table-column>   
                    <el-table-column width="150px" header-align="center" align="center" prop="recover_time" label="恢复时间"></el-table-column> 
            </el-table>
            <!-- 分页部分 -->
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            	:page-sizes="[10,20,50,100]" :current-page="page.currentPage" :page-size="page.pageSize" :total="page.total"
            	layout="total, sizes, prev, pager, next, jumper" style="text-align: center"></el-pagination>
        </el-card>

    </div>
</template>

<script>
    export default {
        name: "grayPlanTraceList",
        data() {
            return {
                queryForm: {
                    recover_status:'1', // 
                    merchant_number:'',  // 
                    merchant_name:'',
                    agent_no:'',
                    p1_agent_no:'',
                    transaction_number:'',
                    terminal_type:'',
                    terminal_sn:'',
                    card_type:'',
                    gray_plan_type:'',
                    start_time:'',
                    end_time:'',
                    start_recover_time:'',
                    end_recover_time:'',
                },
                stockTable: { //列表
                    list: []
                },
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0, //总数
                },
                loading: true,
                downLoading: false, //导出loading
                rangeDate:[],
                rangeDate2:[]
                
            }
        },
        mounted() {
            this.page.currentPage = 1;
            this.queryForm.page = this.page.currentPage;
            this.queryForm.limit = this.page.pageSize;
            this.getData(this.queryForm)
        },
        methods: {
            pickerChange(DateArr) { //时间选择器
                this.queryForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.queryForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            },
            pickerChange2(DateArr) { //时间选择器
                this.queryForm.start_recover_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.queryForm.end_recover_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            },
            
            handleDownLoad(searchForm) { //导出
            	let reqData = {
            		type: 39,
            		value: JSON.stringify(searchForm)
            	};
            	
            	this.downLoading = true; 
            	this.$api.post('export/add', reqData, res => {
            		if (res.code == 0) {
            			this.$message.success(res.msg);
            			this.downLoading = false;
            		} else {
            			this.$message.error(res.msg);
            			this.downLoading = false;
            		}
            	
                })
            },
            onSearch(queryForm) {
                this.page.currentPage = 1;
                queryForm.page = this.page.currentPage;
                queryForm.limit = this.page.pageSize;
                // 表单提交
                this.getData(queryForm);
            },
            //分页
            handleCurrentChange(page) {
                // 获取当前页修改的值
                this.page.currentPage = page;
                this.loading = true;
                this.queryForm.page = page;
                this.queryForm.limit = this.page.pageSize;
                this.getData(this.queryForm);
            },
            handleSizeChange(limit) {
                this.page.currentPage = 1;
                // 获取条数发生改变的值
                this.page.pageSize = limit;
                this.loading = true;
                this.queryForm.page = this.page.currentPage;
                this.queryForm.limit = limit;
                this.getData(this.queryForm);
            },
            getData(params) {
                this.$api.post("gray_list/grayTransactionList", params, res => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.page.total = data.count; //总数
                        this.stockTable.list = data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                    // //渲染结束后取消加载
                    this.loading = false;
                })
            }
        }
    };
</script>

<style lang="scss" scope>
    .MAM_queryList {
        .el-input__inner {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }
    }

    .header>.el-card__body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .headerDivd {
        padding-right: 50px;
        font-size: 14px;
        color: #E6A23C;
    }

    .headerMoney {
        font-size: 28px;
        font-weight: bold;
    }
</style>